import { Select, Spin } from "antd";
import { useState, useRef } from "react";
import toast from "react-hot-toast";
import { IoCloseSharp } from "react-icons/io5";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { Col, Modal, ModalBody, Row } from "reactstrap";
import { getAllSaleOrders, getAllVendors } from "../../api/pagination";
import GeneralButton from "../button/GeneralButton";
import { FiShoppingCart } from "react-icons/fi";

const CreatePurchaseOrder = ({
  modal,
  toggle,
  all_vendors,
  state,
  directPO,
  setShipping,
  handleShippingData,
  setVendorData,
  returnVendor,
  returnOrder,
  selectedOrdersIds,
  setSelectedOrdersIds,
}) => {
  const history = useHistory();
  const { sale_orders } = useSelector((state) => state.orders);
  const [vendor, setVendor] = useState(null);
  const [searchVendors, setSearchVendors] = useState([]);
  const [vendorSearchText, setVendorSearchText] = useState("");
  const vendorDebounceTimerRef = useRef(null);

  const [searchOrders, setSearchOrders] = useState([]);
  const [orderSearchText, setOrderSearchText] = useState("");
  const orderDebounceTimerRef = useRef(null);

  const [dataLoading, setDataLoading] = useState(false);

  const handleVendor = (val) => {
    let data = vendorSearchText ? searchVendors : all_vendors;

    let res =
      data &&
      data?.find((i, index) => {
        return i?._id === val;
      });

    setVendor(res);
    if (directPO) {
      setVendorData(res);
      setShipping(true);
    }
  };

  const handleChange = (value) => {
    setSelectedOrdersIds(value);
  };

  const handleSearchPO = (searchText) => {
    setVendorSearchText(searchText);
    if (vendorDebounceTimerRef.current) {
      clearTimeout(vendorDebounceTimerRef.current);
    }

    if (!searchText) {
      setSearchVendors([]);
      setDataLoading(false);
      return;
    }

    setDataLoading(true);
    vendorDebounceTimerRef.current = setTimeout(() => {
      getAllVendors(1, searchText, 50, (res) => {
        if (res) {
          setSearchVendors(res?.data?.data || []);
        }
        setDataLoading(false);
      });
    }, 500);
  };

  const handleOrderSearch = (searchText) => {
    setOrderSearchText(searchText);
    if (orderDebounceTimerRef.current) {
      clearTimeout(orderDebounceTimerRef.current);
    }

    if (!searchText) {
      setSearchOrders([]);
      setDataLoading(false);
      return;
    }

    setDataLoading(true);
    orderDebounceTimerRef.current = setTimeout(() => {
      getAllSaleOrders("", "", false, "", "", 1, 50, searchText, "desc", (res) => {
        if (res) {
          setSearchOrders(res?.data?.data || []);
        }
        setDataLoading(false);
      });
    }, 500);
  };

  return (
    <Modal isOpen={modal} toggle={toggle} centered onClosed={() => { }}>
      <ModalBody className="p-0 rounded-0">
        <div className="d-flex mb-1 justify-content-between align-items-center p-4 border-bottom bg-light rounded-top">
          <h5 className="fw-bold text-dark mb-0 d-flex align-items-center gap-2">
            <FiShoppingCart className="text-primary mr-2" /> {returnVendor ? "Return Order" : "Purchase Order"}
          </h5>
          <IoCloseSharp size={24} className="text-muted pointer hover-opacity-75" onClick={toggle} style={{ cursor: "pointer" }} />
        </div>
        <Row className=" p-3">
          <Col md={12}>
            <div className="d-flex justify-content-between align-items-end mb-2">
              <label className="fw-bold mb-0">Select Vendor </label>

            </div>
            <Select
              size="large"
              showSearch
              loading={dataLoading}
              notFoundContent={
                dataLoading ? <Spin size="small" /> : "No vendors found"
              }
              placeholder={"Search Vendor"}
              filterOption={false}
              onSelect={(val) => {
                handleVendor(val);
              }}
              onSearch={handleSearchPO}
              className="mb-2 w-100 rounded-0"
              getPopupContainer={(trigger) => trigger.parentNode}
              options={(vendorSearchText ? searchVendors : all_vendors)?.map((option) => ({
                value: option._id,
                label: `${option.id} - ${option?.billing[0]?.company}`,
              })) || []}
            />
          </Col>
          {!returnVendor && (
            <Col md={12}>
              <label className="fw-bold mb-2">Tag Orders </label>
              <Select
                style={{
                  width: 200,
                }}
                mode="multiple"
                showSearch
                loading={dataLoading}
                notFoundContent={
                  dataLoading ? <Spin size="small" /> : "No orders found"
                }
                placeholder={"Search Order ID's"}
                filterOption={false}
                onChange={handleChange}
                onSearch={handleOrderSearch}
                className="mb-2 w-100 rounded-0"
                getPopupContainer={(trigger) => trigger.parentNode}
                options={(orderSearchText ? searchOrders : sale_orders)?.map((option) => ({
                  value: option._id,
                  label: `${option.id}`,
                })) || []}
              />
            </Col>
          )}
          <div className="d-flex justify-content-end mt-3">
            <GeneralButton
              title={"Cancel"}
              className={"bg-white text-black border-1 mx-2 rounded-0"}
              width={"100px"}
              handleClick={toggle}
            />
            <GeneralButton
              title={"Continue"}
              className={"bg-primary-color border-0 rounded-0"}
              width={"100px"}
              handleClick={() => {
                if (vendor === null) {
                  toast.error("Please Select any vendor to proceed !");
                } else if (directPO) {
                  handleShippingData();
                } else if (returnVendor) {
                  returnOrder(vendor);
                } else {
                  history.push({
                    pathname: `/admin/purchase-orders-details/${state?.id}`,
                    state: {
                      obj: state,
                      vendor,
                      new: true,
                      tagSaleOrders: selectedOrdersIds,
                    },
                  });
                }
              }}
            />
          </div>
        </Row>
      </ModalBody>
    </Modal>
  );
};
export default CreatePurchaseOrder;
